import { useEffect } from "react";
import api from "@/lib/api";

// Journalise les clics sur les boutons d'appel (un clic n'est jamais présenté comme un appel abouti).
export default function PhoneClickTracker() {
  useEffect(() => {
    let sid = sessionStorage.getItem("rama_sid");
    if (!sid) { sid = Math.random().toString(36).slice(2); sessionStorage.setItem("rama_sid", sid); }
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="tel:"]');
      if (!a) return;
      api.post("/events/phone-click", { page: window.location.pathname, session_id: sid }).catch(() => {});
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
}
